const state = {
  sidebarCollapsed: false
}

const mutations = {
  SET_SIDEBAR_COLLAPSED (state, collapsed) {
    state.sidebarCollapsed = collapsed
  },
  TOGGLE_SIDEBAR (state) {
    state.sidebarCollapsed = !state.sidebarCollapsed
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
